<template>
  <p>河南智能科技有限公司 &copy; 版权所有</p>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
</style>